/* eslint-disable eqeqeq */
import { $consts, $evt } from 'src/plugins'

export default {
  [$consts['LIFECYCLE/EDIT_PAGE_CONTROL_LOADED']] (EditContext: any, props: any) {
    // formId 没有，代表是新增，此时 onEditPageFormLoaded 不会被执行
    if (!props.current.formData?.formId) {
      $evt.emit($consts['EVT/CONTROL_VISIBLE'], [
        'ENUM',
        'INPUT_DATA_LEVEL',
        'IS_ONLY_CHECK_LEAF',
        'INPUT_DATA_API',
        'INPUT_ID_FIELD',
        'INPUT_SAVE_FIELD',
        'INPUT_NAV_FIELD',
        'INPUT_FILTER_FIELD',
        'INPUT_LABEL_FIELD',
        'INPUT_SHOW_FIELD',
        'INPUT_SORT_FIELD',
        'INPUT_SORT_ORDER',
        'INPUT_FILTER_ORG_TYPE',
        'INPUT_KEEP_VALUE_BY_NO_SRC',
        'MAX_LEN',
        'MIN_LEN',
        'CODE_RULE_TYPE',
        'IS_IGNORE_TENANT',
        'SELECTD_LABEL_FIELD'
      ], false)
    }
  },
  [$consts['LIFECYCLE/EDIT_PAGE_FORM_LOADED']] (EditContext: any, props: any) {
    const { CONTROL_TYPE } = EditContext.formBase
    onEditVisible(CONTROL_TYPE)
  },
  [$consts['LIFECYCLE/EDIT_PAGE_FORM_CHANGE']] (EditContext: any, FIELD_NAME: string, data: any) {
    if (FIELD_NAME === 'CONTROL_TYPE') {
      const { value: CONTROL_TYPE } = data
      onEditVisible(CONTROL_TYPE)
      //文件上传控件默认初始值 /FS/File/UploadFileToImage
      if (CONTROL_TYPE == 200) {
        var val = EditContext.formBase.INPUT_DATA_API
        if (!val) {
          EditContext.setFormBase({
            INPUT_DATA_API: '/FS/File/UploadFileToImage'
          })
        }
      }
    }
  }
}

function onEditVisible (data: any) {
  const controlType = data ? data : 0
  $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['ENUM'], controlType === 3 || controlType === 5)
  $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['INPUT_DATA_LEVEL', 'IS_ONLY_CHECK_LEAF'], controlType === 11 || controlType === 17)
  $evt.emit(
    $consts['EVT/CONTROL_VISIBLE'],
    ['INPUT_DATA_API', 'INPUT_ID_FIELD'],
    controlType === 9
    || controlType === 11
    || controlType === 13
    || controlType === 17
    || controlType === 24
    || controlType === 25
    || controlType === 200
    || controlType === 205
  )
  $evt.emit(
    $consts['EVT/CONTROL_VISIBLE'],
    ['INPUT_SAVE_FIELD', 'INPUT_NAV_FIELD'],
    controlType === 9
    || controlType === 11
    || controlType === 13
    || controlType === 17
    || controlType === 24
    || controlType === 200
    || controlType === 205
  )
  $evt.emit(
    $consts['EVT/CONTROL_VISIBLE'],
    ['INPUT_FILTER_FIELD'],
    controlType === 9
    || controlType === 13
    || controlType === 24
    || controlType === 200
    || controlType === 205
  )
  $evt.emit(
    $consts['EVT/CONTROL_VISIBLE'],
    ['INPUT_LABEL_FIELD', 'INPUT_SHOW_FIELD', 'INPUT_SORT_FIELD', 'INPUT_SORT_ORDER'],
    controlType === 9
    || controlType === 13
    || controlType === 17
    || controlType === 24
    || controlType === 200
    || controlType === 205
  )
  $evt.emit(
    $consts['EVT/CONTROL_VISIBLE'],
    ['INPUT_FILTER_ORG_TYPE', 'INPUT_KEEP_VALUE_BY_NO_SRC'],
    controlType === 9
    || controlType === 13
    || controlType === 17
    || controlType === 24
  )
  $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['MAX_LEN', 'MIN_LEN'], controlType === 1 || controlType === 6 || controlType === 7)
  $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['FILE_TYPES', 'FILE_SIZE'], controlType === 200)
  $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['CODE_RULE_TYPE'], controlType === 14)
  $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['IS_IGNORE_TENANT'], controlType === 9)
  $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['SELECTD_LABEL_FIELD'], controlType === 24)
}
